import {ptracGetEntities} from 'src/utilities/ptracApi'

export default {
  namespaced: true,
  actions: {
    async fetchByPendingJobsWithBlockedInvoiceSubmittalTasks() {
      return await ptracGetEntities('reporting-view/search/findByJobStatusAndStatusAndInvoiceTaskStatus?jobStatus=Pending&status=Completed&invoiceTaskStatus=Blocked', 'reportingViews')
    }
  }
}
